import { Focusable, Tag, TagGroup, TagList, Tooltip, TooltipTrigger } from '@launchpad-ui/components';

import type { Member, SamlConfig } from '../model';

import { getAuthMethodInfo, getStoredCredentials } from './authMethod';

type AuthMethodTagProps = Readonly<{
  member: Member;
  samlConfig?: SamlConfig;
  marketplaceProvider?: string;
}>;

export function AuthMethodTag({ member, samlConfig, marketplaceProvider }: AuthMethodTagProps) {
  const info = getAuthMethodInfo(member, samlConfig, marketplaceProvider);

  if (!info) {
    return null;
  }

  const { label, category, variant, scim } = info;
  const displayLabel = scim ? `${label} (SCIM)` : label;
  const storedCreds = getStoredCredentials(member);
  const showTooltip = storedCreds && samlConfig?.enabled && samlConfig?.requireSso;

  const inner = (
    <span>
      <div className="AuthMethodTag-wrapper">
        <TagGroup aria-label="Authentication method">
          <TagList>
            <Tag size="small" variant={variant}>
              {displayLabel}
            </Tag>
          </TagList>
        </TagGroup>
      </div>
      {category && <small className="pt-text-muted">{category}</small>}
    </span>
  );

  if (showTooltip) {
    return (
      <TooltipTrigger>
        <Focusable>{inner}</Focusable>
        <Tooltip placement="top">{storedCreds}</Tooltip>
      </TooltipTrigger>
    );
  }

  return inner;
}
